import React, { useEffect, useState } from 'react';
import { supabase } from '../../config/supabase';
import { supabaseAuthService } from '../../supabase/auth.service';
import { useWouterRouter } from '../../hooks/useWouterNavigation';
import './AuthCallback.css';

/**
 * Page de callback pour l'authentification OAuth Supabase
 * Version nettoyée - le Service Worker bypass maintenant Supabase correctement
 */
const AuthCallback: React.FC = () => {
  const { navigate } = useWouterRouter();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      console.log('🔐 [Callback] Traitement du retour OAuth...');

      const hash = window.location.hash;
      if (!hash || !hash.includes('access_token')) {
        console.error('❌ [Callback] Pas de tokens dans l\'URL');
        setError('Erreur de connexion. Veuillez réessayer.');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      try {
        const params = new URLSearchParams(hash.substring(1));
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');

        if (!accessToken || !refreshToken) {
          throw new Error('Tokens manquants');
        }

        console.log('🔐 [Callback] Tokens trouvés, initialisation session Supabase...');

        // Nettoyer l'URL avant setSession
        window.history.replaceState(null, '', '/callback');

        // Initialiser la session Supabase (le SW bypass maintenant correctement)
        const { data, error: sessionError } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        });

        if (sessionError) {
          throw sessionError;
        }

        if (data?.user) {
          console.log('✅ [Callback] Session Supabase établie pour:', data.user.email);
          await supabaseAuthService.ensureOrganizerProfile(data.user);
        }

        // Rediriger vers organizer
        console.log('🔐 [Callback] Redirection vers /organizer...');
        navigate('/organizer');

      } catch (err: any) {
        console.error('❌ [Callback] Erreur:', err.message || err);
        setError('Erreur de connexion. Veuillez réessayer.');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="auth-callback">
      <div className="auth-callback__content">
        {error ? (
          <p className="auth-callback__error">{error}</p>
        ) : (
          <>
            <div className="auth-callback__spinner"></div>
            <p className="auth-callback__text">Connecting ...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
